var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.617188,
    width: 11.8349,
    height: 8.13651,
    fill: "#EEF3F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.617188,
    width: 6.65714,
    height: 5.17778,
    fill: "#41479B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.65723,
    y: 0.617188,
    width: 5.17778,
    height: 0.739682,
    fill: "#DC251C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.65723,
    y: 2.09766,
    width: 5.17778,
    height: 0.739683,
    fill: "#DC251C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.65723,
    y: 3.57422,
    width: 5.17778,
    height: 0.739683,
    fill: "#DC251C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.65723,
    y: 5.05469,
    width: 5.17778,
    height: 0.739683,
    fill: "#DC251C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 6.53516,
    width: 11.8349,
    height: 0.739683,
    fill: "#DC251C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 8.01562,
    width: 11.8349,
    height: 0.739683,
    fill: "#DC251C"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.739746,
    y: 1.35547,
    width: 0.739683,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2.21899,
    y: 1.35547,
    width: 0.739683,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 3.69849,
    y: 1.35547,
    width: 0.739682,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 5.17773,
    y: 1.35547,
    width: 0.739683,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0.739746,
    y: 2.83594,
    width: 0.739683,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 2.21899,
    y: 2.83594,
    width: 0.739683,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 3.69849,
    y: 2.83594,
    width: 0.739682,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47949,
    y: 3.57422,
    width: 0.739682,
    height: 0.739683,
    fill: "#C5D0EC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 2.95874,
    y: 3.57422,
    width: 0.739683,
    height: 0.739683,
    fill: "#C5D0EC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 4.43823,
    y: 3.57422,
    width: 0.739683,
    height: 0.739683,
    fill: "#C5D0EC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1.47949,
    y: 2.09375,
    width: 0.739682,
    height: 0.739683,
    fill: "#C5D0EC"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 2.95874,
    y: 2.09375,
    width: 0.739683,
    height: 0.739683,
    fill: "#C5D0EC"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 4.43823,
    y: 2.09375,
    width: 0.739683,
    height: 0.739683,
    fill: "#C5D0EC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 5.17773,
    y: 2.83594,
    width: 0.739683,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 0.739746,
    y: 4.3125,
    width: 0.739683,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 2.21899,
    y: 4.3125,
    width: 0.739683,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 3.69849,
    y: 4.3125,
    width: 0.739682,
    height: 0.739682,
    fill: "#C5D0EC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 5.17773,
    y: 4.3125,
    width: 0.739683,
    height: 0.739682,
    fill: "#C5D0EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/USA.0455b59ac1c839fd92b39dd2c64f81a2.svg";
export { ForwardRef as ReactComponent };